class Pixel{
    constructor(){}

    sendTrack(action, parameters){
        window.fbq('track', action, parameters);
    }
}

export default new Pixel();